<button
  class="close-btn"
  *ngIf="context.closeable"
  (click)="close()"
  tuiIconButton
  tuiPreventDefault="mousedown"
  size="s"
  appearance="aitarget-flat"
  icon="tuiIconCloseLarge"
  shape="rounded"
></button>
<h5 class="tui-text_h5">{{ 'Pricing' | translate }}</h5>
<tui-loader *tuiLet="plans$ | async as plans" [showLoader]="plansLoader" [overlay]="true" size="xl">
  <ng-container *tuiLet="currentPlan$ | async as currentPlan">
    <div class="plan-list">
      <div
        class="plan"
        *ngFor="let plan of plans; last as isLast"
        [class.surpassing]="productCount <= plan.metadata.product_count"
        [class.tui-space_right-6]="!isLast"
      >
        <div class="plan-title">{{ plan?.name | uppercase }}</div>
        <div class="plan-price">
          <span class="info">{{ 'Price, monthly' | translate }}</span>
          {{
            isPriceHasCents(plan?.prices[0]?.unit_amount / 100)
              ? (plan?.prices[0]?.unit_amount / 100 | currency : 'USD' : 'symbol' : '1.2-2')
              : (plan?.prices[0]?.unit_amount / 100 | currency : 'USD' : 'symbol' : '1.0-0')
          }}
        </div>
        <div class="plan-product-limit">
          <span class="info">{{ 'Number of SKUs, up to' | translate }}</span>
          {{ plan?.metadata?.product_count | number }}
        </div>
        <div class="plan-buy-button-wrapper">
          <div
            class="plan-buy-button-inner"
            [tuiHint]="
              !agreement.value
                ? ('You need to accept the agreement before continuing' | translate)
                : ''
            "
            tuiHintDirection="top-right"
          >
            <button
              *ngIf="currentPlan?.id !== plan.id"
              [disabled]="productCount > plan.metadata.product_count || !agreement.value"
              (click)="changePlan(plan)"
              tuiButton
              type="button"
              appearance="pricing-button"
            >
              {{ 'Get!' | translate }}
            </button>
          </div>

          <div class="current-plan" *ngIf="currentPlan?.id === plan.id">
            <tui-svg class="tui-space_right-2" src="tuiIconCheckCircleLarge"></tui-svg>
            {{ 'Your current plan' | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="tui-text_body-xl tui-space_top-7 tui-space_bottom-2">
      <a (click)="showContactModal()" tuiLink>Contact us</a> if you have more than 100,000 SKUs
    </div>
    <div>
      <tui-checkbox-labeled [formControl]="agreement" size="l">
        <div class="tui-text_body-xl">
          I accept the
          <a tuiLink href="https://files.aitarget.com/site/agreement.pdf" target="_blank"
            >agreement</a
          >
        </div>
      </tui-checkbox-labeled>
    </div>
  </ng-container>
</tui-loader>
